module.exports = __webpack_public_path__ + "static/img/12.33f289c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/zh/12.png
// module id = grtr
// module chunks = 0